<app-canvas-layout>
    <div slot="header">
        <app-public-area-header></app-public-area-header>
    </div>
    <div slot="side1" *ngIf="appearance.publicArea.header.menu.show" 
                      style="min-width: 280px; height: 100%;">
        <ng-container *ngIf="!['login','reset_password','set_password'].includes(routingDataService.currentRoutingNodeId)
                            && securityDataService.cookiePolicyAccepted()">
            <app-horizontal-menu context="public"
                                [mobile]="true"
                                [settings]="{mode: appearance.publicArea.header.menu.mode,
                                            spacing: appearance.publicArea.header.menu.spacing,
                                            menuItemStyle: {
                                                fontSize: appearance.publicArea.header.menu.fontSize,
                                                fontColor: appearance.publicArea.header.menu.fontColor,
                                                bgColor: appearance.publicArea.header.menu.bgColor,
                                                borderColor: appearance.publicArea.header.menu.borderColor,
                                                underlineColor: appearance.publicArea.header.menu.underlineColor
                                            },
                                            hoverMenuItemStyle: {
                                                fontColor: appearance.publicArea.header.menu.hoverItemFontColor,
                                                bgColor: appearance.publicArea.header.menu.hoverItemBgColor,
                                                borderColor: appearance.publicArea.header.menu.hoverItemBorderColor,
                                                underlineColor: appearance.publicArea.header.menu.hoverItemUnderlineColor
                                            },
                                            selectedMenuItemStyle: {
                                                fontColor: appearance.publicArea.header.menu.selectedItemFontColor,
                                                bgColor: appearance.publicArea.header.menu.selectedItemBgColor,
                                                borderColor: appearance.publicArea.header.menu.selectedItemBorderColor,
                                                underlineColor: appearance.publicArea.header.menu.selectedItemUnderlineColor
                                            }}">
            </app-horizontal-menu>
        </ng-container>
    </div>
    <div slot="page" style="height: 100%;">
        <ng-content></ng-content>
    </div>
    <div slot="side2">
        <!--Non usato in public area layout-->
    </div>
</app-canvas-layout>